import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./components";

import todoData from "./data";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App todos={todoData} title="todos" />
  </React.StrictMode>
);
